module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/connect-bg-34bb08d2315c425dbfb71b21a6ead122.webp";